import { atom } from 'recoil';

export const attributeSearchAtom = atom<string>({
  key: `AttributeListSearchValueAtom`,
  default: ''
});
